import { history } from "./routing";
/**
 * Grab the app root element
 */

export function getRootDiv() {
  return window.document.getElementById("root");
}
/**
 * Generates an object url from a file
 *
 * !Important: Remember to clear your object url or else you'll cause a memory leak.
 * https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL#Memory_management
 *
 * @param {Object} file
 */

export function createObjectUrl(file) {
  return window.URL.createObjectURL(file);
}
/**
 * Revokes and terminates an object url
 *
 * @param {DOMString} objectUrl
 */

export function revokeObjectUrl(objectUrl) {
  window.URL.revokeObjectURL(objectUrl);
}
/**
 * Scrolls window to top-left (used on route transitions primarily)
 */

export function resetScrollPosition() {
  window.document.body.scrollTop = 0;
  var element = window.document.querySelector("#root");
  if (element) element.scrollTop = 0;
}
/**
 * Scrolls window to a specified location
 */

export function scrollTo(_a) {
  var _b = _a.top,
      top = _b === void 0 ? 0 : _b,
      _c = _a.left,
      left = _c === void 0 ? 0 : _c,
      _d = _a.behavior,
      behavior = _d === void 0 ? "smooth" : _d;
  window.scrollTo({
    top: top,
    left: left,
    behavior: behavior
  });
  var element = window.document.querySelector("#root");
  element === null || element === void 0 ? void 0 : element.scrollTo({
    top: top,
    left: left,
    behavior: behavior
  });
}
/**
 * Grabs the window top and left positions
 */

export function getWindowScrollPosition() {
  var top = window.pageYOffset || document.documentElement.scrollTop;
  var left = window.pageXOffset || document.documentElement.scrollLeft;
  return {
    top: top,
    left: left
  };
}
/**
 * Programatic navigation using reach router
 *
 * @param {String} url
 * @param {Object} options
 */

export function navigateTo(url, options) {
  if (options === void 0) {
    options = {
      imperative: false,
      replace: false
    };
  }

  if (options.imperative) {
    window.location.href = url;
    return;
  }

  if (options.replace) {
    return history.replace(url);
  }

  history.push(url);
}
/**
 * Navigates history back 1 item.
 */

export function navigateBack() {
  // TODO: Do we need this method? Throwing an error now. Talk with the team
  throw new Error("HEY FIX ME!"); // history.goBack()
}
/**
 * Returns true if a child element's bounding box is overflowing the parent element's bounding box
 *
 * @param {HTMLElement} childElem
 * @param {HTMLElement} parentElem
 */

export function isChildOverflowingParent(childElem, parentElem) {
  var childBox = childElem.getBoundingClientRect();
  var parentBox = parentElem.getBoundingClientRect();
  return childBox.left < parentBox.left || childBox.top < parentBox.top || childBox.right > parentBox.right || childBox.bottom > parentBox.bottom;
}
/**
 * Returns the base url without `app.`.
 */

export function getBaseUrl() {
  var _a = window.location,
      protocol = _a.protocol,
      host = _a.host;

  if (host.startsWith("app.")) {
    host = host.substr(4);
  }

  return protocol + "//" + host;
}